import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/design/icon/rabo_logo.jpg'
import _imports_1 from '@/assets/design/icon/ABJ_crop_black.png'
import _imports_2 from '@/assets/design/icon/jasrac_footer_img.jpg'
import _imports_3 from '@/assets/design/icon/nex_tone_footer.png'


const _withScopeId = n => (_pushScopeId("data-v-6f65f396"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l_footer" }
const _hoisted_2 = { class: "footer" }
const _hoisted_3 = { class: "footer_inner" }
const _hoisted_4 = { class: "footer_inner_top" }
const _hoisted_5 = { class: "l_sitemap" }
const _hoisted_6 = { class: "sitemap" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("利用申込み ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("管理画面へ")
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "sitemap sitemap__right" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("利用申込み ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("管理画面へ")
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "footer_inner_bottom" }
const _hoisted_22 = { class: "l_footinfo_left" }
const _hoisted_23 = { class: "footinfo_pic_poplar" }
const _hoisted_24 = { class: "rabo_logo" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footinfo_txt" }, [
  /*#__PURE__*/_createTextVNode(" Copyright © POPLAR Publishing Co.,Ltd All Rights Reserved. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("当サイトに掲載の、写真、動画などの無断転載、加工など一切禁止しております。 ")
], -1))
const _hoisted_26 = { class: "l_footinfo_right" }
const _hoisted_27 = { class: "abj_logo ml-3" }
const _hoisted_28 = { class: "footinfo_pic" }
const _hoisted_29 = ["href"]
const _hoisted_30 = { class: "jasrac_logo" }
const _hoisted_31 = { class: "footinfo_pic_Jasrac" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footinfo_txt jasrac_txt ml-3" }, [
  /*#__PURE__*/_createTextVNode(" JASRAC許諾"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("第901675000"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("7Y45129号 ")
], -1))
const _hoisted_33 = { class: "jasrac_logo" }
const _hoisted_34 = { class: "footinfo_pic_Jasrac" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footinfo_txt jasrac_txt ml-3" }, [
  /*#__PURE__*/_createTextVNode("許諾番号"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ID000009225"),
  /*#__PURE__*/_createElementVNode("br")
], -1))

import { inject, computed, ref, Ref } from 'vue'
import { injectionKeys } from '@/constants/injectionKeys'
import { useRoute } from 'vue-router'
import AuthHelper from '@/helpers/AuthHelper'
import { useDisplay } from 'vuetify'
import config from '@/config/config'
import { errorPageNames } from '@/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const display = ref(useDisplay())
const isNextGiga = inject<Ref<boolean>>(injectionKeys.isNextGiga)!

const clientRegistrationUrl = '/client_registration'

const route = useRoute()

// 404,500,503エラー判定
const isErrorPage = computed(() => {
  return typeof route.name === 'string' && errorPageNames.includes(route.name)
})

/**
 * 管理画面への権限を判定する
 * ユーザ種別が「教育委員会管理者」、「学校管理者」、「先生」、「アドミニストレータ」のいずれか、かつログイン後かつエラーページでない場合のみ表示
 * @returns {boolean} true:権限あり、false:権限なし
 */
const hasAuthAdmin = computed(() => {
  return AuthHelper.isPermittedUser() && !isErrorPage.value
})

/**
 * 管理者権限有無を判定する
 * @returns {boolean} true:管理者権限かつエラーページでない、false:管理者権限以外またはエラーページ
 */
const isUserTypeAdmin = computed(() => {
  return AuthHelper.isAdmin() && !isErrorPage.value
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_img = _resolveComponent("v-img")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("footer", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (!_unref(isNextGiga))
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                    _createElementVNode("a", {
                      href: _unref(config).mottosokkaUrl + _unref(config).termOfServiceChildrenUrl,
                      target: "_blank",
                      class: "sitemap_link"
                    }, "お約束", 8, _hoisted_8)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                (_unref(isNextGiga))
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: _unref(config).mottosokkaUrl + '/giga-school-group-terms',
                      target: "_blank",
                      class: "sitemap_link"
                    }, "団体利用規約", 8, _hoisted_9))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: _unref(config).mottosokkaUrl + _unref(config).termOfServiceUrl,
                      target: "_blank",
                      class: "sitemap_link"
                    }, "団体利用規約", 8, _hoisted_10))
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: _unref(config).websiteAgreementUrl,
                  target: "_blank",
                  class: "sitemap_link"
                }, "ウェブサイト利用規約", 8, _hoisted_11)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: _unref(config).privacyPolicyUrl,
                  target: "_blank",
                  class: "sitemap_link"
                }, "プライバシーポリシー", 8, _hoisted_12)
              ]),
              _withDirectives(_createElementVNode("li", null, [
                _createVNode(_component_v_row, { class: "mr-0" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_v_col, { class: "foot_space" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
                        name: 'ExternalLink',
                        params: {
                          href: _unref(config).mottosokkaUrl + clientRegistrationUrl,
                        },
                      },
                          class: "sitemap_link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(isUserTypeAdmin)]
                    ]),
                    (_unref(hasAuthAdmin))
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          class: "foot_space"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: {
                        name: 'ExternalLink',
                        params: { href: _unref(config).adminUrl },
                      },
                              class: "sitemap_link"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(hasAuthAdmin))
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          class: "foot_space"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: _unref(config).mottoSokkaSupport,
                              target: "_blank",
                              class: "sitemap_link"
                            }, "サポートページ", 8, _hoisted_15)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ], 512), [
                [_vShow, display.value.smAndDown]
              ])
            ]),
            _withDirectives(_createElementVNode("ul", _hoisted_16, [
              _createElementVNode("li", null, [
                _createVNode(_component_v_row, { class: "mr-0" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_v_col, { class: "foot_space" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          to: {
                        name: 'ExternalLink',
                        params: {
                          href: _unref(config).mottosokkaUrl + clientRegistrationUrl,
                        },
                      },
                          class: "sitemap_link"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_17
                          ]),
                          _: 1
                        }, 8, ["to"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _unref(isUserTypeAdmin)]
                    ]),
                    (_unref(hasAuthAdmin))
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          class: "foot_space"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, {
                              to: {
                        name: 'ExternalLink',
                        params: { href: _unref(config).adminUrl },
                      },
                              class: "sitemap_link"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(hasAuthAdmin))
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          class: "pr-0 foot_space"
                        }, {
                          default: _withCtx(() => [
                            (_unref(isNextGiga))
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: _unref(config).nextGigaSupportTop,
                                  target: "_blank",
                                  class: "sitemap_link"
                                }, "サポートページ", 8, _hoisted_19))
                              : (_openBlock(), _createElementBlock("a", {
                                  key: 1,
                                  href: _unref(config).mottoSokkaSupport,
                                  target: "_blank",
                                  class: "sitemap_link"
                                }, "サポートページ", 8, _hoisted_20))
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ])
            ], 512), [
              [_vShow, display.value.mdAndUp]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_v_img, {
                  src: _imports_0,
                  alt: "ポプラ社ロゴ",
                  contain: ""
                })
              ])
            ]),
            _hoisted_25
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("a", {
                  href: _unref(config).mottosokkaUrl + _unref(config).aboutAbjUrl,
                  target: "_blank",
                  class: "footinfo_pic"
                }, [
                  _createVNode(_component_v_img, {
                    src: _imports_1,
                    alt: "ABJマーク",
                    contain: ""
                  })
                ], 8, _hoisted_29)
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_v_img, {
                  src: _imports_2,
                  alt: "Jasrac_img",
                  contain: ""
                })
              ]),
              _hoisted_32
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_v_img, {
                  src: _imports_3,
                  alt: "Jasrac_img",
                  contain: ""
                })
              ]),
              _hoisted_35
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})